
app.controller('CIFHeadCtrl', function ($scope, $window, $q, $http, $location) {
    $scope.stepClass = ['','', '', '', ''];
    $scope.stepActive = 'active current';
    $scope.current = 0;

    //console.log($window);
    

    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: '/service/client.svc/retrieveSession',
        }).then(function (data) {
            if (!data.data.d) {
                $http({
                    method: 'GET',
                    url: '/service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
            else
                $scope.currentUser = data.data.d;
        }, function (error) { }),
    ]);
    
    allPromise.then(function () {

        $http({
            method: 'GET',
            url: '/service/client.svc/getCIF',
        }).then(function (data) {
            if (data.status == 200) {
                if (data.data.d != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;

                    if ($scope.CIFInvestor) {

                        if ($scope.CIFInvestor.Occupation == 1 || $scope.CIFInvestor.Occupation == 2) {

                            $scope.spouseMandatory = true;
                        }
                    }


                }
            }
        }, function (error) { })


        for(var i=1;i<5;i++)
        {
            if ($scope.currentUser.Stage == 4)
            {
                if (i <= $scope.currentUser.Stage)
                    $scope.stepClass[i] = 'done';
            }
            else
            {
                if (i < $scope.currentUser.Stage)
                    $scope.stepClass[i] = 'done';
            }
        }

        switch ($window.location.hash) {
            case "#/cif/data-pribadi": $scope.current = 1; $scope.stepClass[1] = $scope.stepActive; break;
            case "#/cif/data-pekerjaan": $scope.current = 2; $scope.stepClass[2] = $scope.stepActive; break;
            case "#/cif/data-benef": $scope.current = 3; $scope.stepClass[3] = $scope.stepActive; break;
            case "#/cif/data-pendukung": $scope.current = 4; $scope.stepClass[4] = $scope.stepActive; break;
            case "#/cif/data-pernyataan": $scope.current = 5; $scope.stepClass[5] = $scope.stepActive; break;
        }
    });


    $scope.showForm = function (goto) {
        if(goto<= $scope.currentUser.Stage)
        {
            let page = '#/cif/data-pribadi';

            switch (goto) {
                case 1: page = '#/cif/data-pribadi'; break;
                case 2: page = '#/cif/data-pekerjaan'; break;
                case 3: page = '#/cif/data-benef'; break;
                case 4: page = '#/cif/data-pendukung'; break;
                case 5: page = '#/cif/data-pernyataan'; break;
            }
            $window.location.href = page;
            $window.location.reload();
        }
    }

  

});